export default __webpack_public_path__ + "static/media/laundry2-before-2048w.c60a2ecc.avif";